import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { SegmentCMOSService } from 'src/app/services/segment-cmos.service';
import { presentLoader } from 'src/app/util/ion-util';
import { Storage } from '@ionic/storage';
import { UrlHistoryService } from 'src/app/services/url-history.service';
import { PositionService } from 'src/app/services/position.service';
import { RELOAD_POSITIONS_KEY } from 'src/app/util/storage-util';
import { RedirectDestination } from '@bluecrew/crew-member-backend-angular-client';
import { AppRoutingUtil } from 'src/app/util/app-routing-util';


@Component({
  selector: 'app-reject-job-confirmation',
  templateUrl: './reject-job-confirmation.component.html',
  styleUrls: ['./reject-job-confirmation.component.scss'],
})
export class RejectJobConfirmationComponent implements OnInit {

  @Input() jobExternalId: string;
  @Input() isBlueshift: boolean = false;
  @Output() notForMeEvent = new EventEmitter<number>();

  loadingSpinner: HTMLIonLoadingElement;

  // NOTE: positionService.rejectJob() depends on these reasons to either remove
  //       the single job or the entire position. If these are changed, make sure
  //       to update cmb accordingly.
  rejectJobReasons: string[];

  constructor(private readonly loadingCtrl: LoadingController,
              private readonly modalCtrl: ModalController,
              private readonly positionService: PositionService,
              private readonly urlHistory: UrlHistoryService,
              private readonly segmentCMOS: SegmentCMOSService,
              private storage: Storage) { }

  ngOnInit() {
    if (this.isBlueshift) {
      this.rejectJobReasons = [
        'Location won\'t work',
        'I don\'t like the company',
        'I don\'t like the type of work'
      ];
    } else {
      this.rejectJobReasons = [
        'Schedule won\'t work',
        'Wage is too low',
        'Location won\'t work',
        'I don\'t like the company',
        'I don\'t like the type of work'
      ];
    }
  }

  /**
   *   Will remove a single job if "Schedule won't work" or "Wage is too low"
   *   otherwise will remove the entire position
   */
  async rejectJobWithReason(reason: string) {
    this.loadingSpinner = await presentLoader(this.loadingCtrl);

    this.positionService.rejectJob(this.jobExternalId, reason)
      .toPromise()
      .then((response) => {
        this.storage.set(RELOAD_POSITIONS_KEY, true).then(() => {
          this.modalCtrl.dismiss();
          this.loadingSpinner.dismiss();
          this.segmentCMOS.addEvent('rejectJob', { jobId: this.jobExternalId, reason: reason });
          if (response?.redirectTo === RedirectDestination.DetailScreen) {
            this.notForMeEvent.emit();
          } else {
            this.urlHistory.goBackWithDefault(AppRoutingUtil.BROWSE_JOBS);
          }
        });
      })
      .catch(error => {
        // TODO: use a toast to display an error in rejecting job
        this.modalCtrl.dismiss();
        this.loadingSpinner.dismiss();
        this.segmentCMOS.addEvent('rejectJob_failed', 
          { jobId: this.jobExternalId, reason: reason, error: error });
        this.urlHistory.goBackWithDefault(AppRoutingUtil.BROWSE_JOBS);
      });
  }
}
